export default{
	setItem: function(key,value){
		// localStorage.setItem(key,JSON.stringify(value));
		return  new Promise(function(resolve, reject){       
			sessionStorage.setItem(key,JSON.stringify(value));
			resolve(1);
		});
	},
	getItem: function(key){
		// let _value = localStorage.getItem(key);
		let _value = sessionStorage.getItem(key);
		if(_value == '' || _value == null || _value == undefined || _value == 'undefined'){
			return '';
		}else{
			if(typeof _value == 'string'){
				return JSON.parse(_value);
			}else{
				return '';
			}
		}
	},
	// 文件转base64
	getBase64: function(file) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			let fileResult = "";
			reader.readAsDataURL(file.raw);
			//开始转
			reader.onload = function() {
				fileResult = reader.result;
			};
			//转 失败
			reader.onerror = function(error) {
				reject(error);
			};
			//转 结束 resolve 出去
			reader.onloadend = function() {
				resolve(fileResult);
			};
		});
	},
	// 金额添加千分位
	comdify: function (n) {
	    if(!n) return n;
		n += '';
		if (!n.includes('.')) n += '.00';
		if (n.split(".")[1].length == 1) n += '0'; 
		return n.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
			return $1 + ',';
		}).replace(/\.$/, '');
		
	    // let str = n.split('.');
	    // let re = /\d{1,3}(?=(\d{3})+$)/g;
	    // let n1 = str[0].replace(re, "$&,");
	    // return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
	},
	//去除千分位中的‘，’
	delcommafy: function (num){
	    if(!num) return num;
	    num = num.toString();
	    num = num.replace(/,/gi, '');
	    return num;
	},
	// 金额小写转大写
	getAmountOfMoney: function(n) {
		if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)){
			return ''; 
		} else if(n == "0") {
			return "零";
		}else{
			let _unit = "千百拾亿千百拾万千百拾元角分";
			let _str = ""; 
			n += "00"; 
			var p = n.indexOf('.'); 
			if (p >= 0){
				n = n.substring(0, p) + n.substr(p+1, 2); 
			}
			_unit = _unit.substr(_unit.length - n.length); 
			for (var i=0; i < n.length; i++){
				_str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + _unit.charAt(i); 
			}
			return _str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
		}
	}
}